import { ArrowUpRight, Heart, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="section-shell footer-grid">
        <div className="footer-brand"><span className="brand-number">30</span><div><strong>DIAS PARA A LIBERDADE</strong><p>Um guia para trocar o impulso por presença.</p></div></div>
        <div className="footer-help"><span>PRECISA DE AJUDA AGORA?</span><a href="tel:188" data-testid="footer-cvv-link"><Phone size={15} /> CVV 188</a><a href="https://www.jogadoresanonimos.com.br/" target="_blank" rel="noreferrer" data-testid="gamblers-anonymous-link">Jogadores Anônimos <ArrowUpRight size={14} /></a></div>
        <div className="footer-legal"><p><strong>AVISO DE RESPONSABILIDADE.</strong> Este site e o livro são materiais educativos, motivacionais e devocionais. A dependência de jogos de azar é uma condição de saúde; procure atendimento profissional quando necessário.</p><p>© 2026 · Feito com <Heart size={13} fill="currentColor" /> para quem decidiu recomeçar.</p></div>
      </div>
    </footer>
  );
}
